// extracted by css-extract-rspack-plugin
export default {"extra-icons":"extra-icons-kRHfE1","extraIcons":"extra-icons-kRHfE1"};